export default {
  getGeneralReceiptData: state => {
    return state.generalReceiptData
  },
  tableDataGeneralReceipt: state => {
    return state.generalReceiptListData
  },
}
